import { DirectoryConfig } from './../../../models/directory-config.model';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DirectorySearchService } from './../../../services/directory-search/directory-search.service';

@Component({
  selector: 'app-elements-links',
  templateUrl: './elements-links.component.html',
  styleUrls: ['./elements-links.component.scss']
})
export class ElementsLinksComponent implements OnChanges {
  @Input() adbId: string;
  @Input() fieldValue: any;
  @Input() fieldIsExternal: boolean = false;
  @Input() listClass: string = "default";
  @Input() trueLink: boolean = false;
  public widgetConfig: DirectoryConfig;
  public hasMultipleLinks: boolean = false;

  public visibleElements: Object[] = [];

  @Output() actuallyEmpty = new EventEmitter<boolean>();

  constructor(
    private directorySearch: DirectorySearchService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.fieldValue && this.adbId && (changes['fieldValue'] || changes['adbId'] )) {
      this.updateVisibleFields();
    }
  }

  private updateVisibleFields() {
    // console.debug(this.fieldValue);
    this.directorySearch.getAllowedItems(this.adbId).subscribe(allowedIds => {
      // console.debug("List of allowed IDs for " + this.adbId, allowedIds);
      let valuesAsArray: any[] = [];    
      if (Array.isArray(this.fieldValue)) {
        this.hasMultipleLinks = true;
        valuesAsArray = this.fieldValue;
      } else {
        this.hasMultipleLinks = false;
        valuesAsArray = [this.fieldValue];
      }
      // console.debug("List of current values", idsArray);

      let tempVisibleElements = [];
      valuesAsArray.forEach(crtValue => {
        if (allowedIds.includes(crtValue.element_id)){
          tempVisibleElements.push(crtValue);
        }
      });

      // console.debug("Visible values", tempVisibleElements);
      this.visibleElements = tempVisibleElements;
      if (this.visibleElements.length < 1) {
        // console.debug("List of elements ended up empty!")
        this.actuallyEmpty.emit(true);
      } else {
        // console.debug("List of elements still contains values")
        this.actuallyEmpty.emit(false);
      }
    })

    // this.directoryStore.getDirectoryConfig().pipe(
    //   concatMap((config: DirectoryConfig) => {
    //     this.widgetConfig = config;
    //     let idsArray: string[] = [];
        
    //     if (Array.isArray(this.fieldValue)) {
    //       this.hasMultipleLinks = true;
    //       this.fieldValue.forEach(element => {
    //         idsArray.push(element.element_id);
    //       });
    //     } else {
    //       this.hasMultipleLinks = false;
    //       idsArray.push(this.fieldValue.element_id);
    //     }

    //     return this.directorySearch.findElementsByIds(this.adbId, idsArray, [CONSTANTS.name]);
    //   }),
    // ).subscribe((searchResponse) => {
    //   let visibleElements = [];
    //   // console.debug("Found elements", searchResponse);

    //   searchResponse.elements.forEach(crtElement => {
    //     if (crtElement[CONSTANTS.name]) {
    //       if (this.hasMultipleLinks) { // this field has multiple values
    //         const matchingElement = this.fieldValue.find(completeFieldValue => completeFieldValue.element_id == crtElement.element_id);
    //         if (matchingElement != undefined) {
    //           visibleElements.push(matchingElement);
    //         }
    //       } else { // this field only has a single value
    //         if (crtElement.element_id == this.fieldValue.element_id) {
    //           visibleElements.push(this.fieldValue);
    //         }
    //       }
    //     }
    //   });
    //   this.visibleElements = visibleElements;
    //   if (this.visibleElements.length < 1) {
    //     console.debug("List of elements ended up empty!")
    //     this.actuallyEmpty.emit(true);
    //   } else {
    //     this.actuallyEmpty.emit(false);
    //   }
    //   // console.debug("Updated list of visible elements:");
    //   // console.debug(this.visibleElements);
    // });
  }

}
